import { render, staticRenderFns } from "./RadialBarExample.vue?vue&type=template&id=8f3a0772&"
import script from "./RadialBarExample.vue?vue&type=script&lang=js&"
export * from "./RadialBarExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports